import type { CashDenominationRowDto } from './cash-denominations.dto.js';
import type { CashOperationIdentityDto } from './cash-operation-identity.dto.js';

export const cashDenominationCorrectionEffectValues = ['current_inventory', 'audit_only'] as const;
export type CashDenominationCorrectionEffect =
  (typeof cashDenominationCorrectionEffectValues)[number];

export interface CashDenominationCorrectionDto extends CashOperationIdentityDto {
  id: string;
  cashMovementId: string;
  cashLocationId: string;
  cashSessionId: string | null;
  priorRows: CashDenominationRowDto[];
  correctedRows: CashDenominationRowDto[];
  effect: CashDenominationCorrectionEffect;
  countBoundaryCheckpointId: string | null;
  reason: string;
  createdAt: string;
}

export interface CorrectCashDenominationsRequest {
  companyId: string;
  operationId: string;
  cashMovementId: string;
  correctedRows: CashDenominationRowDto[];
  reason: string;
  occurredAt?: string;
}
